export default "__VITE_ASSET__Dz2CulVr__"